import React, {useEffect, useState} from 'react';
import logo from './logo.svg';
import './App.css';
import {basePath} from './options';
import School from './school';


function App() {


  let [html, setHtml] = useState("");
  let [flag, setFlag] = useState(false);
  let [links, setLinks] = useState([]);
  let [done, setDone] = useState([]);
  let [time, setTime] = useState();

  let [useMin, setUseMin] = useState(false);
  let [min, setMin] = useState(2.90);

  let [address, setAddress] = useState("hudson.philip@sccresa.org");

  let [moreInfo, setMoreInfo] = useState(true);

  let [limit, setLimit] = useState(0);
  let [useLimit, setUseLimit] = useState(false);


  useEffect(()=>{
    if(html !== "" ){
      let table = html.split("table>")[1];
      let rows = table.split("tr>");
      let arr = [];
      for(let i = 3; i<rows.length; i++){
        let link = rows[i].split("href=")[1];
        link = link.split('"')[1];
        link = basePath+link;
        link = link.replaceAll("&amp;", "&");
        let name = rows[i].split('>')[2];
        name = name.replaceAll("</a", "");
        arr.push({link:link, name:name});
        i++;
      }
      setLinks(arr);
    }
  }, [flag]);
  let start = ()=>{
    let start = new Date();
    
    setTime(start.getTime());
    fetch(basePath+"/List?email="+address)
      .then(response => response.text())
      .then(html => {setHtml(html); setFlag(true);});
  }
  let timeString = "";
  if(useLimit){
    if (done.length===limit){
      let now = new Date();
      now = now.getTime();
      let diff = now-time;
      let hours = (diff/1000/60/60);
      let minutes = (diff/1000/60)%60;
      let seconds = (diff/1000)%60;
      timeString = hours.toFixed(0)+":"+minutes.toFixed(0)+":"+seconds.toFixed(0);
    }
  }else{
    if (done.length===links.length){
      let now = new Date();
      now = now.getTime();
      let diff = now-time;
      let hours = (diff/1000/60/60);
      let minutes = (diff/1000/60)%60;
      let seconds = (diff/1000)%60;
      timeString = hours.toFixed(0)+":"+minutes.toFixed(0)+":"+seconds.toFixed(0);
    }
  }
  

  let changeFun = ()=>{
    setUseMin(!useMin);
  };
  let addressFun = (event)=>{
    let string = event.target.value;
    setAddress(string);
  };
  let minFun = (event)=>{
    setMin(event.target.value);
  };
  let showFun = ()=>{
    setMoreInfo(!moreInfo);
  };
  
  return (
    <div className="App">
      
        <h1>Clock Data Crawler</h1>
        <hr/>
        <h3>Options</h3>
        <label htmlFor="address">Email Address: </label>
        <input type="text" value={address} onChange={addressFun} style={{width:"500px"}}/>
        <br/>
        <br/>
        <label htmlFor="useLimBtn">Limit rows crawled: </label>
        <input type="checkbox" onChange={()=>setUseLimit(!useLimit)} checked={useLimit} id="useLimBtn"/>
        <input type="number" value={limit} onChange={(event)=>setLimit(event.target.value)} style={{display:(useLimit)?"inline-block":"none"}}/>
        <br/>
        <br/>
        <label htmlFor="useMinBtn">Use Minimum value for sorting: </label>
        <input type="checkbox" onChange={changeFun} checked={useMin} id="useMinBtn"/>
        <input type="number" value={min} onChange={minFun} style={{display:(useMin)?"inline-block":"none"}}/>
        <br/>
        <br/>
        <label htmlFor="moreInfo">Show more clock info: </label>
        <input type="checkbox" onChange={showFun} checked={moreInfo} id="moreInfo"/>
        <hr/>
        <button onClick={()=>start()}><h3>Start</h3></button>
        <p>Progress: |{(useLimit)? ((done.length/limit)*100).toFixed(0) : ((done.length/links.length)*100).toFixed(0)}%| {timeString}</p>
        {links.map((element, i) => {
          if(i<limit || !useLimit){
            return <School
            key={element.name}
            name={element.name}
            link={element.link}
            setDone={setDone}
            doneList={done}
            useMin={useMin}
            min={min}
            moreInfo={moreInfo}
            
          />
          }else{
            return <span key={element.name}></span>
          }
          
        })}

      
    </div>
  );
}

export default App;
